
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {},
  "__swiper": {
    "bundled": true
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/vercel/path0/node_modules/.c12/github_teamnovu_nuxt_Dxz30oS7Ez/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
